export function Table() {
    return (
        <div className="calcite-mode-dark" id='feature-table-container'>
            <div id='feature-table' />
        </div>
    );
}
